import { RouteRecordRaw } from 'vue-router';
import { Layout } from '@/router/constant';
import { InteractionOutlined, SnippetsOutlined} from '@vicons/antd';
import { PricetagOutline, LocationOutline } from '@vicons/ionicons5';
import { ComputerFilled } from '@vicons/material'
import { renderIcon } from '@/utils/index';

/**
 * @param name 路由名称, 必须设置,且不能重名
 * @param meta 路由元信息（路由附带扩展信息）
 * @param redirect 重定向地址, 访问这个路由时,自定进行重定向
 * @param meta.disabled 禁用整个菜单
 * @param meta.title 菜单名称
 * @param meta.icon 菜单图标
 * @param meta.keepAlive 缓存该路由
 * @param meta.permissions 配置系统权限, 缺省开放所有权限
 * @param meta.alwaysShow 总是显示菜单
 * @param meta.isRoot 单级菜单
 * */
const routes: Array<RouteRecordRaw> = [
  {
    path: '/catalog',
    name: 'catalog',
    redirect: '/catalog/item',
    component: Layout,
    meta: {
      title: 'Catalog',
      icon: renderIcon(InteractionOutlined),
      //这里配置父级路由需要哪些权限可访问 这里是子路由权限集合
      permissions: [
        'catalog_item_read',
        'catalog_location_read',
        'catalog_specification_read',
        'catalog_imit_specification_read',
      ],
      sort: 2,
    },
    children: [
      {
        path: 'item',
        name: 'catalog_item',
        meta: {
          title: 'Item',
          spname: 'item_multi',
          icon: renderIcon(PricetagOutline),
          //配置该路由需要哪些权限可访问 这里是针对单个路由
          permissions: ['catalog_item_read'],
        },
        component: () => import('@/views/catalog/item/index.vue'),
      },
      {
        path: 'location',
        name: 'catalog_location',
        meta: {
          title: 'Location',
          icon: renderIcon(LocationOutline),
          //配置该路由需要哪些权限可访问 这里是针对单个路由
          permissions: ['catalog_location_read'],
        },
        component: () => import('@/views/catalog/location/index.vue'),
      },
      {
        path: 'specification',
        name: 'catalog_specification',
        meta: {
          title: 'Specification',
          spname: 'specification_multi',
          icon: renderIcon(SnippetsOutlined),
          //配置该路由需要哪些权限可访问 这里是针对单个路由
          permissions: ['catalog_specification_read'],
        },
        component: () => import('@/views/catalog/specification/index.vue'),
      },
      {
        path: 'imit-specification',
        name: 'catalog_imit_specification',
        meta: {
          title: 'IMIT Specification',
          spname: 'imit_specification_multi',
          icon: renderIcon(ComputerFilled),
          //配置该路由需要哪些权限可访问 这里是针对单个路由
          permissions: ['catalog_imit_specification_read'],
        },
        component: () => import('@/views/catalog/imit-specification/index.vue'),
      },
    ],
  },
];

export default routes;
